import config from '@/config'
import Reactions, { IReaction, ReactionType } from '@/models/Reaction'
import { useGlobalStore } from '@/store/app'
import { PaginationParams } from '@/types/PaginationParams'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class ReactionsServiceCls extends BaseService<Reactions> {
  constructor() {
    super(null as any)
  }

  model() {
    return Reactions
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}/content`
  }

  async create(data: IReaction): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${data.contentId}/reactions`,
      data
    )
    return response?.data
  }

  async deleteReaction(contentId: string, reactionId: string): Promise<any> {
    const response = await http.delete(
      `${this.endpoint}/${contentId}/reactions/${reactionId}`
    )
    return response?.data
  }

  async getReactions(
    contentId: string,
    reactionType?: ReactionType,
    paginationObject?: PaginationParams
  ): Promise<any> {
    const response = await http.get(`${this.endpoint}/${contentId}/reactions`, {
      params: {
        reactionType,
        ...paginationObject,
      },
    })
    return response?.data
  }
}

// Export singleton instance
export const ReactionsService = new ReactionsServiceCls()

// Export type for dependency injection
export type IReactionsService = ReactionsServiceCls

// Export commonly used methods directly
export const { create, deleteReaction, getReactions } = ReactionsService
